import { Component, OnInit, ViewChild} from '@angular/core';
import { MatChipInputEvent } from '@angular/material/chips';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import {DateAdapter} from '@angular/material/core';
import {TranslateService} from 'ng2-translate/ng2-translate';
import { GeneralService } from '../../services/general.service';
import { GroupService } from '../../services/group.service';
import {ModalConfirmComponent} from '../../modal-confirm/modal-confirm.component';
import { ProvidersService } from '../../services/providers.service';
import {ApproverServicesDetailComponent} from "../approver-services-detail/approver-services-detail.component";

import * as decode from 'jwt-decode';
import * as XLSX from 'xlsx';
import {DatePipe} from '@angular/common';
import {FormControl} from '@angular/forms';
import {Observable} from 'rxjs';
import {map, startWith} from 'rxjs/operators';
import {COMMA, ENTER, SPACE} from '@angular/cdk/keycodes';
import { saveAs } from 'file-saver/FileSaver';

@Component({
  selector: 'app-approver-services',
  templateUrl: './approver-services.component.html',
  styleUrls: ['./approver-services.component.scss']
})
export class ApproverServicesComponent implements OnInit {
  userId: any;
  userToken: any;
  listOrders: any = [];
  temp: any = [];
  load = true;
  expanded: any = {};
  @ViewChild('table', { static: false }) table: any;
 
  myControl = new FormControl();
  filteredOptions: Observable<string[]>;
  
  providersList=[];
  data: any = {};
  providerActive = 'hide';
  isExternal;
  perfilId;
  arrOc = [];
  selectable = true;
  removable = true;
  addOnBlur = true;
  readonly separatorKeysCodes: number[] = [ENTER, COMMA, SPACE];
  loadBtn = false;
  listSocieties = [];

  constructor(private toastr: ToastrService, public dialog: MatDialog, private gralService: GeneralService, private groupService: GroupService, private provService: ProvidersService) {
    this.userToken =  localStorage.getItem('G13xTfsdf234TVsd23513ffdgFdf2352');
    const d = this.userToken.split('Bearer ');
    const tokenPayload = decode(d[1]);
    this.userId = tokenPayload.Id;
    gralService.changeTextHead('APPROVESERVICES');

    //this.getOrders();

    this.isExternal = tokenPayload.EsUsuarioExterno;
    this.perfilId = tokenPayload.IdPerfil;
    this.providerActive = (this.perfilId == '3' && this.isExternal )? 'hide': 'show';
    this.getSocieties();
  }

  ngOnInit() {
    this.loadProviders();
    this.filteredOptions = this.myControl.valueChanges
      .pipe(
        startWith(''),
        map(value => this._filter(value))
      );
    this.data.FechaFin = new Date();
  }

  /* ********************* filtros ************** */ 
  search(){
    
    this.data.Proveedor = this.arrOc.join();

    if(!this.data.Sociedad || !this.data.FechaInicio || !this.data.FechaFin){
      this.toastr.error('Favor de ingresar todos los campos', 'Error');
      return;
    }

    this.listOrders = [];
    this.loadBtn = true;
    const datePipe = new DatePipe('en-US');
    const dateinit = this.data.FechaInicio;
    const dateend = this.data.FechaFin;
    const params = {FechaFin: datePipe.transform(dateend, 'yyyy/MM/dd'), FechaInicio: datePipe.transform(dateinit, 'yyyy/MM/dd'), Proveedor: this.data.Proveedor, Sociedad: this.data.Sociedad, usuario: this.userId};
    
    this.provService.getCloseOrders(params, this.userToken).then((data) => {    
      this.loadBtn = false;
      this.listOrders = data['Entidades'];
      this.temp = data['Entidades'];
      this.reorderDataExportExcel(data['Entidades']);

      if(this.listOrders.length == 0){
        this.toastr.success('No se encontraron resultados para su busqueda', 'Sin Datos');
        return false;
      }
      
    }, (err) => {
        console.log(err);
        this.listOrders = null;
        this.temp = null;
        this.loadBtn = false;
        this.toastr.error('--', 'Error');// ver como esta url regresa los errores
        if(err.status == 401){
          this.gralService.actDeacUser(false);
        }

    });
  }

  disabledProv(){
    let resp = false;
    
    if(this.data.Sociedad){
      const society = this.listSocieties.find(x => x.NoSociedad == this.data.Sociedad);
      if(society.NumProveedor){
        resp = true;
        
      }
    }
    return resp;
  }

  add(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;
    console.log('entro', value)
    // Add our fruit
    if ((value || '').trim()) {
      this.arrOc.push(value.trim());
    }

    // Reset the input value
    if (input) {
      input.value = '';
    }
  }

  remove(oc): void {
    const index = this.arrOc.indexOf(oc);
    if (index >= 0) {
      this.arrOc.splice(index, 1);
    }
  }

  paste(event: ClipboardEvent): void {
    event.preventDefault();
    event.clipboardData
      .getData('Text')
      .split(/;|,|\n/)
      .forEach(value => {
        const string = value.split(' ');
        if(string){
          string.forEach(val => {
            if(val.trim()){
              this.arrOc.push(val.trim());
            }
          });
        }else{
          if(value.trim()){
            this.arrOc.push(value.trim());
          }
        }
      })
  }
  
  addProveedorSearch(option){
    console.log('option', option);
    let value = this.myControl.value;
    if ((value || '').trim()) {
      let proveedor = value.split(' - ');      
      this.arrOc.push(proveedor[0]);
    }

    this.myControl.setValue('');
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.providersList.filter(option => option.toLowerCase().includes(filterValue));
  }

  loadProviders(){
    this.provService.getProvidersNum(this.userToken).then((res:any)=>{
      this.providersList = res.Entidades;
    });
  }

  getSocieties(){
    this.provService.getSociedades(this.userId, this.userToken).then((data) => {
      this.loadBtn = false;
      if(data['EsValido']){
        this.listSocieties = data['Entidades'];
        if(this.listSocieties.length == 1){
          this.data.society = this.listSocieties[0].NoSociedad;
          this.data.Sociedad = this.listSocieties[0].NoSociedad;
          this.selectSociety(0);
          
        }
      }else{
        this.listSocieties = null;
      }
    }, (err) => {
      console.log(err);
      this.loadBtn = false;
      this.listSocieties = null;
      if(err.status == 401){
        this.gralService.actDeacUser(false);
      }
    });
  }

  selectSociety(pos){
    if(this.perfilId==3){
      let List = this.listSocieties;
      this.arrOc = [];      
      this.arrOc.push(List[pos].NumProveedor);
    }
  }
  /* ********************* filtros ************** */

  listExcel =  [];
  reorderDataExportExcel(lista){
    this.listExcel =  [];
    
    for(let i = 0; i < lista.length; i++){
      let contTable = lista[i].RecepcionFactura;      
      
      let params = {
          "Serie": contTable.Serie,
          "Folio": contTable.Folio,
          "RFC Emisor" : contTable.RFCEmisor,
          "Número de proveedor" : contTable.NumProveedor,
          "Fecha de emisión": contTable.FechaEmision,
          "Fecha de carga" : contTable.FechaCarga,
          "Estatus": contTable.EstatusProcesoFactura.Descripcion,      
          "Doc. Factura":  lista[i].Resultado.InvoiceDocumentMiro ,
          "Año Doc. Factura": lista[i].Resultado.InvoiceDocumentYearMiro
      }
      this.listExcel.push(params);
    }  
  }
  
}
